import { useCallback, useRef, useState } from 'react';

interface PullToRefreshResult {
  pullDistance: number;
  refreshing: boolean;
  handlers: {
    onTouchStart: (e: React.TouchEvent) => void;
    onTouchMove: (e: React.TouchEvent) => void;
    onTouchEnd: () => void;
  };
}

export function usePullToRefresh(onRefresh: () => void): PullToRefreshResult {
  const [pullDistance, setPullDistance] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(0);
  const active = useRef(false);

  const onTouchStart = useCallback((e: React.TouchEvent) => {
    if (window.scrollY <= 0) {
      active.current = true;
      startY.current = e.touches[0].clientY;
    }
  }, []);

  const onTouchMove = useCallback((e: React.TouchEvent) => {
    if (!active.current) return;
    const diff = e.touches[0].clientY - startY.current;
    if (diff > 0 && window.scrollY <= 0) {
      setPullDistance(Math.min(diff * 0.45, 80));
    }
  }, []);

  const onTouchEnd = useCallback(() => {
    if (pullDistance > 45) {
      setRefreshing(true);
      setPullDistance(50);
      window.setTimeout(() => {
        onRefresh();
        setRefreshing(false);
        setPullDistance(0);
      }, 900);
    } else {
      setPullDistance(0);
    }
    active.current = false;
  }, [pullDistance, onRefresh]);

  return { pullDistance, refreshing, handlers: { onTouchStart, onTouchMove, onTouchEnd } };
}